import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  fetch(instance) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          whatsappProfile (
            instance_id: ${instance.id}
          ) {
            about,
            address,
            description,
            email,
            profile_picture_url,
            vertical,
            messaging_product,
            websites
          }
        }
      `
    })
  },
  update(instance) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateWhatsappProfile (
            instance_id: ${instance.id},
            data: {
              about: """${instance.profile.about}""",
              messaging_product: "${instance.profile.messaging_product}",
              `+ (instance.profile.email != null ? `email: "${instance.profile.email}", ` : '') +   `,
              `+ (instance.profile.address != null ? `address: """${instance.profile.address}""", ` : '') +   `,
              `+ (instance.profile.description != null ? `description: """${instance.profile.description}""", ` : '') +   `,
              `+ (instance.profile.websites != null ? `websites: [${instance.profile.websites.map(data => {return `"${data}"`}).join(',')}], ` : '') +   `,
            }
          )
        }
      `
    })
  },
  updatePicture(instance) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updatePictureWhatsappProfile (
            instance_id: ${instance.id},
            image_url: "${instance.picture}"
          )
        }
      `
    })
  },
}

